import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { CiStatusFilter as CiStatusFilterEnum } from '../client-insurer-index/client-insurer-index-types';
import { CiStatusFilterProps, StatusFilterLabelText } from './filter-types';

const FILTER_SX = { minWidth: 230, maxWidth: 230 };

export const CiStatusFilter = ({
  control,
}: CiStatusFilterProps): JSX.Element => {
  const options = [
    { value: CiStatusFilterEnum.All, label: 'All' },
    { value: CiStatusFilterEnum.Active, label: 'Active' },
    { value: CiStatusFilterEnum.Inactive, label: 'Inactive' },
  ];

  return (
    <Controller
      control={control}
      name="ciStatus"
      render={({ field: { onChange, value } }): JSX.Element => {
        const selectedOption =
          options.find(option => option.value === value) ?? options[0];
        return (
          <Autocomplete
            id="ci-status-select"
            value={selectedOption}
            options={[...options]}
            disableClearable
            size="small"
            sx={FILTER_SX}
            onChange={(_, newValue): void => onChange(newValue.value)}
            getOptionLabel={(option): string => option.label}
            isOptionEqualToValue={(option, val): boolean =>
              option.value === val.value
            }
            renderInput={(params): JSX.Element => (
              <HHTextField
                {...params}
                hhVariant="variant-bypass"
                variant="standard"
                label={StatusFilterLabelText.CI_STATUS}
              />
            )}
          />
        );
      }}
    />
  );
};
